:host.clickable {
  cursor: pointer;
}

:host.highlighted {
  outline: 1px solid #ff7070 !important;
  display: block;
}
